
import { IEntityMetaData, IPropretyAttribute } from "../../../_models/IEntityMetaData";
import { PropretyAttributes, NestedProperty } from "../../../decorators/EntityDecorators";
import { PointOfService } from "../PointOfService.model";
import { Employee } from "../Employee.model";
import { GenericEntityBase } from "../../../_models/GenericEntityBase";

export class Employee_POS extends GenericEntityBase<string> {
  private _id?: string = undefined;
  override get id(): string {
    if (this._id == null) {
      this._id = `[${this.fK_PointOfService},${this.fK_Employee}]`;
    }
    return this._id;
  }

  override _isRelationEntity = true;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required, IPropretyAttribute.KeyProperty] })
  fK_PointOfService!: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required, IPropretyAttribute.KeyProperty] })
  fK_Employee!: number;

  @NestedProperty({ TargetType: PointOfService })
  pointOfService?: PointOfService;

  @NestedProperty({ TargetType: Employee })
  employee?: Employee;

  isTruckerResponsible!: boolean;

  GetType(): IEntityMetaData {
    return Employee_POS.getMetaData();
  }
}
